import React, { useState } from 'react'
import { FaFileWord, FaHammer } from 'react-icons/fa';
import { MdBrush} from 'react-icons/md';
import { VscGear } from 'react-icons/vsc';
import styled from 'styled-components'
import bgImg from '../../Asset/img/mim.jpg';
import serSvg from '../../Asset/img/service.svg'
import { Service } from '../../components/comp';
const Services = () => {
  const [isDetail, setIsDetail] = useState(false)
  return (
    <MainServiceWrapper>
      <ServicesWrapper>
        <ServiceHeroCon>
          <h1>Your Business Online Traffic Our Most Priority</h1>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur corporis sed nulla qui quibusdam consequuntur error impedit eius praesentium est!</p>
          <div className="s-btn" role={'button'}>
            Know More
          </div>
        </ServiceHeroCon>
      </ServicesWrapper>
      <ReadMoreSer>
        <ReadImgWrapper>
          <div className="imgBox">
            <img src={serSvg} alt="" />
           </div>
        </ReadImgWrapper>
        <ReadTextWrapper>
          <div className="head">
            <span>|| Project Tackle</span>
            <h1>Service Procedure</h1>
          </div>
          <div className="con">
            <div className="pro">
               <span>
                <FaFileWord className='p-ico'/>
               </span>
              <h2>Product Management</h2>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam tempore consequuntur hic, odit officia doloribus?</p>
            </div>
            <div className="pro">
              <span>
                <MdBrush className='p-ico'/>
               </span>
              <h2>Product Designing</h2>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam tempore consequuntur hic, odit officia doloribus?</p>
            </div>
            <div className="pro">
              <span>
                <FaHammer className='p-ico'/>
               </span>
             <h2>Develope & Go Digital </h2>
             <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam tempore consequuntur hic, odit officia doloribus?</p>
            </div>
            <div className="pro">
             <span>
                <VscGear  className='p-ico'/>
             </span>
              <h2>Software Maintenance</h2>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam tempore consequuntur hic, odit officia doloribus?</p>
            </div>
          </div>
        </ReadTextWrapper>
      </ReadMoreSer>
      <Service close={isDetail} show={setIsDetail} />
      {isDetail && <ServiceDetail className={isDetail ? 'ease' : ''}>
      </ServiceDetail>}
    </MainServiceWrapper>
  )
}

const MainServiceWrapper = styled.section`
  padding: 60px 0;
  overflow-x: hidden;
`

const ServicesWrapper = styled.article`
  padding: 0 20px;
  min-height: 100vh;
  background: linear-gradient(120deg, var(--bg-color), var(--bga-color)),url(${bgImg});
  background-position: center;
  background-size: cover;
  @media screen and (max-width: 768px){
    min-height: 65vh;
    padding: 0;
  }
  @media screen and (max-width: 430px){
    min-height: 65vh;
    padding: 0;
  }
`

const ServiceHeroCon = styled.article`
 height: 50%;
 width: 50%;
 position: absolute;
 top: 12rem;


 h1{
  font-size: 3rem;
  font-weight: 700;
  color: var(--main-color);
 }

 p{
  color: var(--main-color);
  font-size: 1.04rem;
  font-weight: 600;
  line-height: 1.7;
  max-width: 550px;
  padding: 15px 0;
 }

 .s-btn{
   background: var(--bg-color);
   border-radius: 50px;
   box-shadow: 0 .5rem 1rem var(--bga-color);
   color: var(--main-color);
   cursor: pointer;
   width: 35%;
   padding: 15px 10px;
   text-align: center;
   font-weight: bold;
   transition: all 300ms ease-in-out;

   &:active{
    transform: scale(0.95);
   }
 }
 @media screen and (max-width: 768px){
  width: 98%;
  text-align: center;
  top: 14rem;
   h1{
    font-size: 1.9rem;
   }
   p{
    margin: 0 auto;
   }
  .s-btn{
    margin: 0 auto;
    padding: 15px 0;
    width: 40%;
  }
 }
 @media screen and (max-width: 430px){
  width: 98%;
  text-align: center;
  top: 12rem;
   h1{
    font-size: 1.9rem;
   }
  .s-btn{
    margin: 0 auto;
    padding: 15px 0;
    width: 60%;
  }
 }
`

const ReadMoreSer = styled.article`
  padding: 100px 20px;
  display: grid;
  grid-template-columns: 38% 60%;
  place-items: center;
  gap: 2%;
  @media screen and (max-width: 768px){
    grid-template-columns: 100%;
  }
  @media screen and (max-width: 430px){
    grid-template-columns: 100%;
  }
`
const ReadImgWrapper = styled.div`
  width: 100%;
  .imgBox{
    width: 100%;
    margin: auto;
    img{
      width: 100%;
    }
  }
`

const ReadTextWrapper = styled.div`
  width: 100%;
 .head{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
   span{
    color: var(--bg-color);
    font-weight: 700;
   }

   h1{
    font-size: 2.5rem;
    font-weight: 700;
    padding: 10px 0;
   }
 }
 .con{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  border-radius: 5px;
  width: 90%;
  min-height: 85vh;
  transform: translateX(4rem);

  .pro{
    width: 98%;
    margin: 0 auto;
    height: 300px;
    background: #fff;
    border-radius: .2rem;
    box-shadow: 0 0 10px rgba(7, 61, 122, 0.068);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    transition: 2s ease-in-out;
    &:hover{
      transform: translateX(3px);
    }

    span{
      background: linear-gradient(var(--bg-color),var(--ico-color));
      border-radius: 50px;
      box-shadow: 0 0 10px var(--bga-color);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 60px;

      .p-ico{
        color: var(--main-color);
        font-size: 30px;
      }
    }

    h2{
      font-size: 1.4rem;
      font-weight: 700;
      color: var(--bg-color);
    }

    p{
      font-size: 15px;
      font-weight: 600;
      text-align: center;
      line-height: 1.7;
      padding: 0 8px;
    }
  }
 }

 @media screen and (max-width: 768px){
  .head{
    h1{
      font-size: 2rem;
    }
  }
  .con{
    grid-template-columns: 1fr 1fr;
    transform: translate(0);
    width: 100%;
    margin-top: 2%;
  }
 }

 @media screen and (max-width: 430px){
  .head{
    h1{
      font-size: 2rem;
    }
  }
  .con{
    grid-template-columns: 1fr;
    transform: translate(0);
    width: 100%;
  }
 }
`

const ServiceDetail = styled.div`
  background: red;
  height: 40vh;
  width: 98%;
  margin: 0 auto;
  transform: translateY(-9rem);

  .ease{
    transition: translate 5s ease-in-out;
  }
`
export default Services